import React from 'react'
import ReactDOM from 'react-dom'

// Modal creates a div and displays whatever children 
// are defined within <Modal> children... </Modal>
// Modal requires 'root' element to be provided
// Example: <Modal root={this.state.modalRoot}>
// Its caller responsibility to make sure that root exists on DOM
// Example: in caller: componentDidMount(){... this.setState({modalRoot: document.getElementById('modal-root')})}


export default class Modal extends React.Component {
    constructor(props) {
      super(props)
      // Create a div that we'll render the modal into. Because each
      // Modal component has its own element, we can render multiple
      // modal components into the modal container.
      this.el = document.createElement('div')
      this.state = {
        mounted: false
      }
    }
  
    componentDidMount() {
      // Append the element into the DOM on mount. We'll render
      // into the modal container element (see the HTML tab).
      //console.log("in-Modal-props", this.props)

        if (this.props.root){
            // document.getElementById('modal-root').appendChild(this.el)
            this.props.root.appendChild(this.el)
            this.setState({
                mounted: true
            })
            //console.log('Modal added child',this.props.root)
        } else
            console.log('Modal DID NOT add a child', this.props.root)
        document.getElementById("main-win").style.display = "none";
    }
  
    componentWillUnmount() { // Remove the element from the DOM when we unmount
      if (this.el)
        this.props.root.removeChild(this.el)
      document.getElementById("main-win").style.display = "block";

    }
    
    render() {
      // Use a portal to render the children into the element
      return ReactDOM.createPortal(
        this.state.mounted ? this.props.children : null, // Any valid React child: JSX, strings, arrays, etc.
        this.el // A DOM element
      )
    }
  }